import { Component } from '@angular/core';

@Component({
  selector: 'app-banner-demo-t4',
  templateUrl: './banner-demo-t4.component.html',
})
export class BannerDemoT4Component {}